import { Component, Input } from '@angular/core';
import { RemoteControlDeviceState } from 'app/modules/remote-control/services/device-state-registry.service';
import { RemoteControlVideoRecordingService } from 'xsmodules/remote-control/services/video-recording.service';

@Component({
  selector: 'app-remote-control-video-recording-toolbar',
  templateUrl: './video-recording-toolbar.component.html',
  styleUrls: ['./video-recording-toolbar.component.scss'],
})
export class RemoteControlVideoRecordingToolbarComponent {
  @Input() rcState: RemoteControlDeviceState;

  public get isRecording() {
    return this.rcState.recording;
  }

  public get recordingPaused() {
    return this.rcState.recordingPaused;
  }

  constructor(private remoteControlVideoRecordingService: RemoteControlVideoRecordingService) {}

  // Logic for pausing/resuming recording
  // depending on the current state
  public pauseResumeRecording() {
    if (this.rcState.recordingPaused) {
      this.remoteControlVideoRecordingService.resumeVideoRecording();
    } else {
      this.remoteControlVideoRecordingService.pauseVideoRecording();
    }
  }

  public stopRecording() {
    this.remoteControlVideoRecordingService.stopVideoRecording();
  }
}
